const CRC_TABLE = [
  0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50a5, 0x60c6, 0x70e7, 0x8108, 0x9129, 0xa14a, 0xb16b, 0xc18c, 0xd1ad,
  0xe1ce, 0xf1ef,
] as const;

function updateCrc(crc: number, byte: number): number {
  const updateStep = (current: number, next: number) => CRC_TABLE[((current >> 12) ^ next) & 0x0f] ^ (current << 4);
  return updateStep(updateStep(crc, byte >> 4), byte);
}

export function crc16Ccitt(data: Uint8Array, startIndex = 0): number {
  let crc = 0;

  for (let index = startIndex; index < data.length; index += 1) {
    crc = updateCrc(crc, data[index]);
  }

  return crc & 0xffff;
}

export function formatCrc(crc: number): string {
  return `0x${crc.toString(16).toUpperCase().padStart(4, '0')}`;
}
